import { PhoneNumberItem } from '../../gzSingleSelectListPhoneCode/types';

export const phoneCodes: PhoneNumberItem[] = [
  { country: 'Afghanistan', label: '+93', countryCode: 'AF', value: 1, id: '1' },
  { country: 'Albania (Republic of)', label: '+355', countryCode: 'AL', value: 2, id: '2' },
  { country: "Algeria (People's Democratic Republic of)", label: '+213', countryCode: 'DZ', value: 3, id: '3' },
  { country: 'American Samoa', label: '+1', countryCode: 'AS', value: 4, id: '4' },
  { country: 'Andorra (Principality of)', label: '+376', countryCode: 'AD', value: 5, id: '5' },
  { country: 'Angola (Republic of)', label: '+244', countryCode: 'AO', value: 6, id: '6' },
  { country: 'Anguilla', label: '+1', countryCode: 'AI', value: 7, id: '7' },
  { country: 'Antigua and Barbuda', label: '+1', countryCode: 'AG', value: 8, id: '8' },
  { country: 'Argentine Republic', label: '+54', countryCode: 'AR', value: 9, id: '9' },
  { country: 'Armenia (Republic of)', label: '+374', countryCode: 'AM', value: 10, id: '10' },
  { country: 'Aruba', label: '+297', countryCode: 'AW', value: 11, id: '11' },
  { country: 'Australia', label: '+61', countryCode: 'AU', value: 12, id: '12' },
  { country: 'Australian External Territories', label: '+672', countryCode: 'AU', value: 13, id: '13' },
  { country: 'Austria', label: '+43', countryCode: 'AT', value: 14, id: '14' },
  { country: 'Azerbaijan (Republic of)', label: '+994', countryCode: 'AZ', value: 15, id: '15' },
  { country: 'Bahamas (Commonwealth of the)', label: '+1', countryCode: 'BS', value: 16, id: '16' },
  { country: 'Bahrain (Kingdom of)', label: '+973', countryCode: 'BH', value: 17, id: '17' },
  { country: "Bangladesh (People's Republic of)", label: '+880', countryCode: 'BD', value: 18, id: '18' },
  { country: 'Barbados', label: '+1', countryCode: 'BB', value: 19, id: '19' },
  { country: 'Belgium', label: '+32', countryCode: 'BE', value: 20, id: '20' },
  { country: 'Belize', label: '+501', countryCode: 'BZ', value: 21, id: '21' },
  { country: 'Benin (Republic of)', label: '+229', countryCode: 'BJ', value: 22, id: '22' },
  { country: 'Bermuda', label: '+1', countryCode: 'BM', value: 23, id: '23' },
  { country: 'Bhutan (Kingdom of)', label: '+975', countryCode: 'BT', value: 24, id: '24' },
  { country: 'Bolivia (Plurinational State of)', label: '+591', countryCode: 'BO', value: 25, id: '25' },
  { country: 'Bonaire, Sint Eustatius and Saba', label: '+599', countryCode: 'BQ', value: 26, id: '26' },
  { country: 'Bosnia and Herzegovina', label: '+387', countryCode: 'BA', value: 27, id: '27' },
  { country: 'Botswana (Republic of)', label: '+267', countryCode: 'BW', value: 28, id: '28' },
  { country: 'Brazil (Federative Republic of)', label: '+55', countryCode: 'BR', value: 29, id: '29' },
  { country: 'British Virgin Islands', label: '+1', countryCode: 'VG', value: 30, id: '30' },
  { country: 'Brunei Darussalam', label: '+673', countryCode: 'BN', value: 31, id: '31' },
  { country: 'Bulgaria (Republic of)', label: '+359', countryCode: 'BG', value: 32, id: '32' },
  { country: 'Burkina Faso', label: '+226', countryCode: 'BF', value: 33, id: '33' },
  { country: 'Burundi (Republic of)', label: '+257', countryCode: 'BI', value: 34, id: '34' },
  { country: 'Cabo Verde (Republic of)', label: '+238', countryCode: 'CV', value: 35, id: '35' },
  { country: 'Cambodia (Kingdom of)', label: '+855', countryCode: 'KH', value: 36, id: '36' },
  { country: 'Cameroon (Republic of)', label: '+237', countryCode: 'CM', value: 37, id: '37' },
  { country: 'Canada', label: '+1', countryCode: 'CA', value: 38, id: '38' },
  { country: 'Cayman Islands', label: '+1', countryCode: 'KY', value: 39, id: '39' },
  { country: 'Central African Republic', label: '+236', countryCode: 'CF', value: 40, id: '40' },
  { country: 'Chad (Republic of)', label: '+235', countryCode: 'TD', value: 41, id: '41' },
  { country: 'Chile', label: '+56', countryCode: 'CL', value: 42, id: '42' },
  { country: "China (People's Republic of)", label: '+86', countryCode: 'CN', value: 43, id: '43' },
  { country: 'Colombia (Republic of)', label: '+57', countryCode: 'CO', value: 44, id: '44' },
  { country: 'Comoros (Union of the)', label: '+269', countryCode: 'KM', value: 45, id: '45' },
  { country: 'Congo (Republic of the)', label: '+242', countryCode: 'CG', value: 46, id: '46' },
  { country: 'Cook Islands', label: '+682', countryCode: 'CK', value: 47, id: '47' },
  { country: 'Costa Rica', label: '+506', countryCode: 'CR', value: 48, id: '48' },
  { country: "Côte d'Ivoire (Republic of)", label: '+225', countryCode: 'CI', value: 49, id: '49' },
  { country: 'Croatia (Republic of)', label: '+385', countryCode: 'HR', value: 50, id: '50' },
  { country: 'Curaçao', label: '+599', countryCode: 'CW', value: 51, id: '51' },
  { country: 'Cyprus (Republic of)', label: '+357', countryCode: 'CY', value: 52, id: '52' },
  { country: 'Czech Republic', label: '+420', countryCode: 'CZ', value: 53, id: '53' },
  { country: 'Democratic Republic of the Congo', label: '+243', countryCode: 'CD', value: 54, id: '54' },
  { country: 'Denmark', label: '+45', countryCode: 'DK', value: 55, id: '55' },
  { country: 'Diego Garcia', label: '+246', countryCode: 'IO', value: 56, id: '56' },
  { country: 'Djibouti (Republic of)', label: '+253', countryCode: 'DJ', value: 57, id: '57' },
  { country: 'Dominica (Commonwealth of)', label: '+1', countryCode: 'DM', value: 58, id: '58' },
  { country: 'Dominican Republic', label: '+1', countryCode: 'DO', value: 59, id: '59' },
  { country: 'Ecuador', label: '+593', countryCode: 'EC', value: 60, id: '60' },
  { country: 'Egypt (Arab Republic of)', label: '+20', countryCode: 'EG', value: 61, id: '61' },
  { country: 'El Salvador (Republic of)', label: '+503', countryCode: 'SV', value: 62, id: '62' },
  { country: 'Equatorial Guinea (Republic of)', label: '+240', countryCode: 'GQ', value: 63, id: '63' },
  { country: 'Eritrea', label: '+291', countryCode: 'ER', value: 64, id: '64' },
  { country: 'Estonia (Republic of)', label: '+372', countryCode: 'EE', value: 65, id: '65' },
  { country: 'Ethiopia (Federal Democratic Republic of)', label: '+251', countryCode: 'ET', value: 66, id: '66' },
  { country: 'Falkland Islands (Malvinas)', label: '+500', countryCode: 'FK', value: 67, id: '67' },
  { country: 'Faroe Islands', label: '+298', countryCode: 'FO', value: 68, id: '68' },
  { country: 'Fiji (Republic of)', label: '+679', countryCode: 'FJ', value: 69, id: '69' },
  { country: 'Finland', label: '+358', countryCode: 'FI', value: 70, id: '70' },
  { country: 'France', label: '+33', countryCode: 'FR', value: 71, id: '71' },
  {
    country: 'French Departments and Territories in the Indian Ocean',
    label: '+262',
    countryCode: 'RE',
    value: 72,
    id: '72',
  },
  { country: 'French Guiana (French Department of)', label: '+594', countryCode: 'GF', value: 73, id: '73' },
  {
    country: "French Polynesia (Territoire français d'outre-mer)",
    label: '+689',
    countryCode: 'PF',
    value: 74,
    id: '74',
  },
  { country: 'Gabonese Republic', label: '+241', countryCode: 'GA', value: 75, id: '75' },
  { country: 'Gambia (Republic of the)', label: '+220', countryCode: 'GM', value: 76, id: '76' },
  { country: 'Georgia', label: '+995', countryCode: 'GE', value: 77, id: '77' },
  { country: 'Germany (Federal Republic of)', label: '+49', countryCode: 'DE', value: 78, id: '78' },
  { country: 'Ghana', label: '+233', countryCode: 'GH', value: 79, id: '79' },
  { country: 'Gibraltar', label: '+350', countryCode: 'GI', value: 80, id: '80' },
  { country: 'Greece', label: '+30', countryCode: 'GR', value: 81, id: '81' },
  { country: 'Greenland (Denmark)', label: '+299', countryCode: 'GL', value: 82, id: '82' },
  { country: 'Grenada', label: '+1', countryCode: 'GD', value: 83, id: '83' },
  { country: 'Guadeloupe (French Department of)', label: '+590', countryCode: 'GP', value: 84, id: '84' },
  { country: 'Guam', label: '+1', countryCode: 'GU', value: 85, id: '85' },
  { country: 'Guatemala (Republic of)', label: '+502', countryCode: 'GT', value: 86, id: '86' },
  { country: 'Guinea (Republic of)', label: '+224', countryCode: 'GN', value: 87, id: '87' },
  { country: 'Guinea-Bissau (Republic of)', label: '+245', countryCode: 'GW', value: 88, id: '88' },
  { country: 'Guyana', label: '+592', countryCode: 'GY', value: 89, id: '89' },
  { country: 'Haiti (Republic of)', label: '+509', countryCode: 'HT', value: 90, id: '90' },
  { country: 'Honduras (Republic of)', label: '+504', countryCode: 'HN', value: 91, id: '91' },
  { country: 'Hong Kong, China', label: '+852', countryCode: 'HK', value: 92, id: '92' },
  { country: 'Hungary', label: '+36', countryCode: 'HU', value: 93, id: '93' },
  { country: 'Iceland', label: '+354', countryCode: 'IS', value: 94, id: '94' },
  { country: 'India (Republic of)', label: '+91', countryCode: 'IN', value: 95, id: '95' },
  { country: 'Indonesia (Republic of)', label: '+62', countryCode: 'ID', value: 96, id: '96' },
  { country: 'Iraq (Republic of)', label: '+964', countryCode: 'IQ', value: 97, id: '97' },
  { country: 'Ireland', label: '+353', countryCode: 'IE', value: 98, id: '98' },
  { country: 'Israel (State of)', label: '+972', countryCode: 'IL', value: 99, id: '99' },
  { country: 'Italy', label: '+39', countryCode: 'IT', value: 100, id: '100' },
  { country: 'Jamaica', label: '+1', countryCode: 'JM', value: 101, id: '101' },
  { country: 'Japan', label: '+81', countryCode: 'JP', value: 102, id: '102' },
  { country: 'Jordan (Hashemite Kingdom of)', label: '+962', countryCode: 'JO', value: 103, id: '103' },
  { country: 'Kazakhstan (Republic of)', label: '+7', countryCode: 'KZ', value: 104, id: '104' },
  { country: 'Kenya (Republic of)', label: '+254', countryCode: 'KE', value: 105, id: '105' },
  { country: 'Kiribati (Republic of)', label: '+686', countryCode: 'KI', value: 106, id: '106' },
  { country: 'Korea (Republic of)', label: '+82', countryCode: 'KR', value: 107, id: '107' },
  { country: 'Kosovo', label: '+383', countryCode: 'XK', value: 108, id: '108' },
  { country: 'Kuwait (State of)', label: '+965', countryCode: 'KW', value: 109, id: '109' },
  { country: 'Kyrgyz Republic', label: '+996', countryCode: 'KG', value: 110, id: '110' },
  { country: "Lao People's Democratic Republic", label: '+856', countryCode: 'LA', value: 111, id: '111' },
  { country: 'Latvia (Republic of)', label: '+371', countryCode: 'LV', value: 112, id: '112' },
  { country: 'Lebanon', label: '+961', countryCode: 'LB', value: 113, id: '113' },
  { country: 'Lesotho (Kingdom of)', label: '+266', countryCode: 'LS', value: 114, id: '114' },
  { country: 'Liberia (Republic of)', label: '+231', countryCode: 'LR', value: 115, id: '115' },
  { country: 'Libya', label: '+218', countryCode: 'LY', value: 116, id: '116' },
  { country: 'Liechtenstein (Principality of)', label: '+423', countryCode: 'LI', value: 117, id: '117' },
  { country: 'Lithuania (Republic of)', label: '+370', countryCode: 'LT', value: 118, id: '118' },
  { country: 'Luxembourg', label: '+352', countryCode: 'LU', value: 119, id: '119' },
  { country: 'Macao, China', label: '+853', countryCode: 'MO', value: 120, id: '120' },
  { country: 'Madagascar (Republic of)', label: '+261', countryCode: 'MG', value: 121, id: '121' },
  { country: 'Malawi', label: '+265', countryCode: 'MW', value: 122, id: '122' },
  { country: 'Malaysia', label: '+60', countryCode: 'MY', value: 123, id: '123' },
  { country: 'Maldives (Republic of)', label: '+960', countryCode: 'MV', value: 124, id: '124' },
  { country: 'Mali (Republic of)', label: '+223', countryCode: 'ML', value: 125, id: '125' },
  { country: 'Malta', label: '+356', countryCode: 'MT', value: 126, id: '126' },
  { country: 'Marshall Islands (Republic of the)', label: '+692', countryCode: 'MH', value: 127, id: '127' },
  { country: 'Martinique (French Department of)', label: '+596', countryCode: 'MQ', value: 128, id: '128' },
  { country: 'Mauritania (Islamic Republic of)', label: '+222', countryCode: 'MR', value: 129, id: '129' },
  { country: 'Mauritius (Republic of)', label: '+230', countryCode: 'MU', value: 130, id: '130' },
  { country: 'Mexico', label: '+52', countryCode: 'MX', value: 131, id: '131' },
  { country: 'Micronesia (Federated States of)', label: '+691', countryCode: 'FM', value: 132, id: '132' },
  { country: 'Moldova (Republic of)', label: '+373', countryCode: 'MD', value: 133, id: '133' },
  { country: 'Monaco (Principality of)', label: '+377', countryCode: 'MC', value: 134, id: '134' },
  { country: 'Mongolia', label: '+976', countryCode: 'MN', value: 135, id: '135' },
  { country: 'Montenegro', label: '+382', countryCode: 'ME', value: 136, id: '136' },
  { country: 'Montserrat', label: '+1', countryCode: 'MS', value: 137, id: '137' },
  { country: 'Morocco (Kingdom of)', label: '+212', countryCode: 'MA', value: 138, id: '138' },
  { country: 'Mozambique (Republic of)', label: '+258', countryCode: 'MZ', value: 139, id: '139' },
  { country: 'Myanmar (the Republic of the Union of)', label: '+95', countryCode: 'MM', value: 140, id: '140' },
  { country: 'Namibia (Republic of)', label: '+264', countryCode: 'NA', value: 141, id: '141' },
  { country: 'Nauru (Republic of)', label: '+674', countryCode: 'NR', value: 142, id: '142' },
  { country: 'Nepal (Federal Democratic Republic of)', label: '+977', countryCode: 'NP', value: 143, id: '143' },
  { country: 'Netherlands (Kingdom of the)', label: '+31', countryCode: 'NL', value: 144, id: '144' },
  {
    country: "New Caledonia (Territoire français d'outre-mer)",
    label: '+687',
    countryCode: 'NC',
    value: 145,
    id: '145',
  },
  { country: 'New Zealand', label: '+64', countryCode: 'NZ', value: 146, id: '146' },
  { country: 'Nicaragua', label: '+505', countryCode: 'NI', value: 147, id: '147' },
  { country: 'Niger (Republic of the)', label: '+227', countryCode: 'NE', value: 148, id: '148' },
  { country: 'Nigeria (Federal Republic of)', label: '+234', countryCode: 'NG', value: 149, id: '149' },
  { country: 'Niue', label: '+683', countryCode: 'NU', value: 150, id: '150' },
  {
    country: 'Northern Mariana Islands (Commonwealth of the)',
    label: '+1',
    countryCode: 'MP',
    value: 151,
    id: '151',
  },
  { country: 'Norway', label: '+47', countryCode: 'NO', value: 152, id: '152' },
  { country: 'Oman (Sultanate of)', label: '+968', countryCode: 'OM', value: 153, id: '153' },
  { country: 'Pakistan (Islamic Republic of)', label: '+92', countryCode: 'PK', value: 154, id: '154' },
  { country: 'Palau (Republic of)', label: '+680', countryCode: 'PW', value: 155, id: '155' },
  { country: 'Panama (Republic of)', label: '+507', countryCode: 'PA', value: 156, id: '156' },
  { country: 'Papua New Guinea', label: '+675', countryCode: 'PG', value: 157, id: '157' },
  { country: 'Paraguay (Republic of)', label: '+595', countryCode: 'PY', value: 158, id: '158' },
  { country: 'Peru', label: '+51', countryCode: 'PE', value: 159, id: '159' },
  { country: 'Philippines (Republic of the)', label: '+63', countryCode: 'PH', value: 160, id: '160' },
  { country: 'Pitcairn', label: '+872', countryCode: 'PN', value: 161, id: '161' },
  { country: 'Poland (Republic of)', label: '+48', countryCode: 'PL', value: 162, id: '162' },
  { country: 'Portugal', label: '+351', countryCode: 'PT', value: 163, id: '163' },
  { country: 'Puerto Rico', label: '+1', countryCode: 'PR', value: 164, id: '164' },
  { country: 'Qatar (State of)', label: '+974', countryCode: 'QA', value: 165, id: '165' },
  { country: 'Romania', label: '+40', countryCode: 'RO', value: 166, id: '166' },
  { country: 'Rwanda (Republic of)', label: '+250', countryCode: 'RW', value: 167, id: '167' },
  { country: 'Saint Helena, Ascension and Tristan Da Cunha', label: '+247', countryCode: 'SH', value: 168, id: '168' },
  { country: 'Saint Helena, Ascension and Tristan da Cunha', label: '+290', countryCode: 'SH', value: 169, id: '169' },
  { country: 'Saint Kitts and Nevis', label: '+1', countryCode: 'KN', value: 170, id: '170' },
  { country: 'Saint Lucia', label: '+1', countryCode: 'LC', value: 171, id: '171' },
  { country: 'Saint Pierre and Miquelon', label: '+508', countryCode: 'PM', value: 172, id: '172' },
  { country: 'Saint Vincent and the Grenadines', label: '+1784', countryCode: 'VC', value: 173, id: '173' },
  { country: 'Samoa (Independent State of)', label: '+685', countryCode: 'WS', value: 174, id: '174' },
  { country: 'San Marino (Republic of)', label: '+378', countryCode: 'SM', value: 175, id: '175' },
  {
    country: 'Sao Tome and Principe (Democratic Republic of)',
    label: '+239',
    countryCode: 'ST',
    value: 176,
    id: '176',
  },
  { country: 'Saudi Arabia (Kingdom of)', label: '+966', countryCode: 'SA', value: 177, id: '177' },
  { country: 'Senegal (Republic of)', label: '+221', countryCode: 'SN', value: 178, id: '178' },
  { country: 'Serbia (Republic of)', label: '+381', countryCode: 'RS', value: 179, id: '179' },
  { country: 'Seychelles (Republic of)', label: '+248', countryCode: 'SC', value: 180, id: '180' },
  { country: 'Sierra Leone', label: '+232', countryCode: 'SL', value: 181, id: '181' },
  { country: 'Singapore (Republic of)', label: '+65', countryCode: 'SG', value: 182, id: '182' },
  { country: 'Sint Maarten (Dutch part)', label: '+1', countryCode: 'SX', value: 183, id: '183' },
  { country: 'Slovak Republic', label: '+421', countryCode: 'SK', value: 184, id: '184' },
  { country: 'Slovenia (Republic of)', label: '+386', countryCode: 'SI', value: 185, id: '185' },
  { country: 'Solomon Islands', label: '+677', countryCode: 'SB', value: 186, id: '186' },
  { country: 'Somalia (Federal Republic of)', label: '+252', countryCode: 'SO', value: 187, id: '187' },
  { country: 'South Africa (Republic of)', label: '+27', countryCode: 'ZA', value: 188, id: '188' },
  { country: 'South Sudan (Republic of) ', label: '+211', countryCode: 'SS', value: 189, id: '189' },
  { country: 'Spain', label: '+34', countryCode: 'ES', value: 190, id: '190' },
  { country: 'Sri Lanka (Democratic Socialist Republic of)', label: '+94', countryCode: 'LK', value: 191, id: '191' },
  { country: 'Sudan (Republic of the)', label: '+249', countryCode: 'SD', value: 192, id: '192' },
  { country: 'Suriname (Republic of)', label: '+597', countryCode: 'SR', value: 193, id: '193' },
  { country: 'Swaziland (Kingdom of)', label: '+268', countryCode: 'SZ', value: 194, id: '194' },
  { country: 'Sweden', label: '+46', countryCode: 'SE', value: 195, id: '195' },
  { country: 'Switzerland (Confederation of)', label: '+41', countryCode: 'CH', value: 196, id: '196' },
  { country: 'Taiwan, China', label: '+886', countryCode: 'TW', value: 197, id: '197' },
  { country: 'Tajikistan (Republic of)', label: '+992', countryCode: 'TJ', value: 198, id: '198' },
  { country: 'Tanzania (United Republic of)', label: '+255', countryCode: 'TZ', value: 199, id: '199' },
  { country: 'Thailand', label: '+66', countryCode: 'TH', value: 200, id: '200' },
  { country: 'The Former Yugoslav Republic of Macedonia', label: '+389', countryCode: 'MK', value: 201, id: '201' },
  { country: 'Timor-Leste (Democratic Republic of)', label: '+670', countryCode: 'TL', value: 202, id: '202' },
  { country: 'Togolese Republic', label: '+228', countryCode: 'TG', value: 203, id: '203' },
  { country: 'Tokelau', label: '+690', countryCode: 'TK', value: 204, id: '204' },
  { country: 'Tonga (Kingdom of)', label: '+676', countryCode: 'TO', value: 205, id: '205' },
  { country: 'Trinidad and Tobago', label: '+1', countryCode: 'TT', value: 206, id: '206' },
  { country: 'Tunisia', label: '+216', countryCode: 'TN', value: 207, id: '207' },
  { country: 'Turkey', label: '+90', countryCode: 'TR', value: 208, id: '208' },
  { country: 'Turkmenistan', label: '+993', countryCode: 'TM', value: 209, id: '209' },
  { country: 'Turks and Caicos Islands', label: '+1', countryCode: 'TC', value: 210, id: '210' },
  { country: 'Tuvalu', label: '+688', countryCode: 'TV', value: 211, id: '211' },
  { country: 'Uganda (Republic of)', label: '+256', countryCode: 'UG', value: 212, id: '212' },
  { country: 'Ukraine', label: '+380', countryCode: 'UA', value: 213, id: '213' },
  { country: 'United Arab Emirates', label: '+971', countryCode: 'AE', value: 214, id: '214' },
  {
    country: 'United Kingdom of Great Britain and Northern Ireland',
    label: '+44',
    countryCode: 'GB',
    value: 215,
    id: '215',
  },
  { country: 'United States of America', label: '+1', countryCode: 'US', value: 216, id: '216' },
  { country: 'United States Virgin Islands', label: '+1', countryCode: 'VI', value: 217, id: '217' },
  { country: 'Universal Personal Telecommunication Service', label: '+878', countryCode: 'UPT', value: 218, id: '218' },
  { country: 'Uruguay (Eastern Republic of)', label: '+598', countryCode: 'UY', value: 219, id: '219' },
  { country: 'Uzbekistan (Republic of)', label: '+998', countryCode: 'UZ', value: 220, id: '220' },
  { country: 'Vanuatu (Republic of)', label: '+678', countryCode: 'VU', value: 221, id: '221' },
  { country: 'Vatican City State', label: '+39', countryCode: 'VA', value: 222, id: '222' },
  { country: 'Vatican City State', label: '+379', countryCode: 'VA', value: 223, id: '223' },
  { country: 'Venezuela (Bolivarian Republic of)', label: '+58', countryCode: 'VE', value: 224, id: '224' },
  { country: 'Viet Nam (Socialist Republic of)', label: '+84', countryCode: 'VN', value: 225, id: '225' },
  {
    country: "Wallis and Futuna (Territoire français d'outre-mer)",
    label: '+681',
    countryCode: 'WF',
    value: 226,
    id: '226',
  },
  { country: 'Yemen (Republic of)', label: '+967', countryCode: 'YE', value: 227, id: '227' },
  { country: 'Zambia (Republic of)', label: '+260', countryCode: 'ZM', value: 228, id: '228' },
  { country: 'Zimbabwe (Republic of)', label: '+263', countryCode: 'ZW', value: 229, id: '229' },
];

/**
 * Convert country code to prefix. Example: 'RO' => '+40'
 *
 * @param countryCode
 */
export const convertCountryCodeToPrefix = function (countryCode: string): string {
  return phoneCodes.find(code => code.countryCode === countryCode)?.label ?? '';
};
